<template>
    <LinkHover
        :type="'a'"
        :href="layout.externallink.url"
        target="_blank"
        :classNames="{
            default: 'link-default',
            hover: 'link-hover',
            hoverMask: 'link-hover-mask'
        }"
        class="link external-link"
    >
        <div class="default">
            <div class="container">
                <div
                    class="tag-container"
                >
                    <span class="tag">{{layout.externallink.tag}}</span>
                </div>
                <div
                    class="heading"
                >
                    <h4 v-html="layout.externallink.title"/>
                </div>
                <div
                    class="baseline"
                >
                    <p v-html="layout.externallink.description"/>
                </div>
            </div>
            <div class="footer">
                <span class="date">{{layout.date}}</span>
                <IconLink/>
            </div>
        </div>
        <template v-slot:hover>
            <div class="hover">
                <div class="bg-cross-animated"></div>
                <div class="container">
                    <div
                        class="tag-container"
                    >
                        <span class="tag">{{layout.externallink.tag}}</span>
                    </div>
                    <div
                        class="heading"
                    >
                        <h4 v-html="layout.externallink.title"/>
                    </div>
                    <div
                        class="baseline"
                    >
                        <p v-html="layout.externallink.description"/>
                    </div>
                </div>
                <div class="footer">
                    <span class="date">{{layout.date}}</span>
                    <IconLink/>
                </div>
            </div>
        </template>
    </LinkHover>
</template>

<script>
import IconLink from '@/components/IconLink'
import LinkHover from '@/components/animation/LinkHover'
export default {
    components: {
        IconLink,
        LinkHover
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
a
    text-decoration: none
    cursor: pointer
.container
    padding-right: 17%

    .heading
        flex: 1
        display: flex
        flex-direction: column
        justify-content: flex-end
        padding-bottom: 10%
        h4
            .board &
                line-height: 1.0714285714
    .tag
        color: #114991
.baseline
    flex: 1
    /deep/ p,
    p
        line-height: 1.5294117647
        color: #777b84
svg
    width: 15px
    height: 15px
    /deep/ path
        fill: #114991

.link
    // padding-top: 178px
    // padding-right: 75px
    // padding-bottom: 85px
    // padding-left: 85px
    /deep/ .link-default
        display: flex
        flex: 1
        .default
            display: flex
            flex-direction: column
    /deep/ .link-hover
        background: #ff2b2a
    /deep/ .link-hover-mask
        // padding-top: 178px
        // padding-right: 75px
        // padding-bottom: 85px
        // padding-left: 85px
        .hover
            color: #FFFFFF
            display: flex
            flex-direction: column
        .container
            .tag
                color: #FFFFFF
        .date
            color: #FFFFFF
        .baseline p
            color: #FFFFFF
        svg
            path
                fill: #FFFFFF
</style>
